export { default as HeroBannerV2 } from './hero-banner';
export { default as heroBannerConfigV2 } from './hero-banner.config';

export { default as HeroBannerV1 } from './hero-banner-v1';
export { default as heroBannerConfigV1 } from './hero-banner-v1.config';
